module.exports = __webpack_public_path__ + "static/shopify_tam-df329bf48c8dacf56aef6e958c767a33.jpg";